// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SettingItem_wrapper__3YRWI","title":"SettingItem_title__2PYr2"};